import { AddressLink } from 'Modules'

import { getContract } from 'hooks/contract/use-contract-viem'
import { clientWallet, publicWallet } from 'libs/viem/config'
import { logError, logInfo } from 'utils/logger'

/** RevenueSharingRental (V2 pool) - updateEndTime(newEndTime) */
const ABI_RENTAL_UPDATE_END_TIME = [
  {
    inputs: [{ internalType: 'uint256', name: 'newEndTime', type: 'uint256' }],
    name: 'updateEndTime',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]

/**
 * System Actions (SRS 5.8/5.9) - stop rental rewards by capping the pool's
 * end time at now via updateEndTime on the pool contract itself.
 */
export const useStopRentalRewards = () => {
  const stopRentalRewards = async (address: AddressLink, poolAddress: string) => {
    if (!address) throw new Error('Wallet is not connected')
    if (!poolAddress) throw new Error('Rental pool contract is missing')

    const contract = getContract({
      contractAddress: poolAddress as `0x${string}`,
      ABI: ABI_RENTAL_UPDATE_END_TIME,
    })

    try {
      const newEndTime = BigInt(Math.floor(Date.now() / 1000))
      logInfo('Stop rental rewards', { poolAddress, newEndTime })

      const { request } = await contract.simulate.updateEndTime([newEndTime], {
        account: address,
      })
      const txHash = await clientWallet?.writeContract(request)

      const receipt = await publicWallet.waitForTransactionReceipt({
        hash: txHash,
        confirmations: 5,
      })

      return { txHash, receipt }
    } catch (error) {
      logError('error stop rental rewards on-chain-----------------', error)
      throw error
    }
  }

  return { stopRentalRewards }
}
